import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import me from './me'
import campaign from './campaign'
import branch from './branch'
import product from './product'
import loading from './loading'
import coupon from './coupon'
import order from './order'
import payment from './payment'
import couponPurchased from './couponPurchased'
import logs from './logs'
import pagination from './pagination'
import preRegister from './pre-register'

import createLogger from './logger'
import staticPage from './static-page'
import productQuota from './productQuota'
import report from './report'
import sms from './sms'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.VUE_APP_ENV === 'local'
const plugins = []

if (debug) {
  plugins.push(createLogger())
  //   plugins.push(createPersistedState())
}

// const dataState = createPersistedState({
//   key: 'pagination',
//   paths: ['pagination', 'campaign.selectTab'],
// })

export default new Vuex.Store({
  // plugins: [dataState],
  modules: {
    auth,
    me,
    campaign,
    branch,
    product,
    loading,
    coupon,
    order,
    payment,
    couponPurchased,
    logs,
    pagination,
    preRegister,
    staticPage,
    productQuota,
    report,
    sms,
  },
  strict: debug,
})
